import React from 'react'
import Dbnav from './Dbnav'
import { useNavigate } from 'react-router-dom';
const DeliveryBoyPanel = () => {
  var nav=useNavigate()
  function navOrders(){
    nav('/DeliveryBoyPanel/Orders')
  }
  return (
    <>
    <Dbnav/>
    <div className="card h-100 text-center panel" id='panel1'>
        <div className="card-body row ">
          <i className="fas fa-truck icon col" onClick={()=>navOrders()}></i>
        </div>
        <div className="card-body row content">
          <b className="col">Orders to Delivery</b>
        </div>
      </div>
    </>
  )
}

export default DeliveryBoyPanel